import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const SupplierEmails = lazy(() => import("@/pages/admin/Mailbox/SupplierEmails/SupplierEmails"));

const Error404 = lazy(() => import("@/pages/Error404"));

const mailboxRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "supplier-emails",
    children: [
      {
        index: true,
        element: <SupplierEmails />,
      },
    ],
  },
];

export default mailboxRoutes;
